import APIKit from '../Allapis/Apikit/apikit'

export const getRedemptionsServer = async () => {
  const endpoint = 'redemptions/list'
  const res = await APIKit.get(endpoint)
  return res.data
}
